var plain = {
  style: 'decimal',
  maximumFractionDigits: 20,
  useGrouping: false
};
var decimal2MinIntegerNoFraction = {
  style: 'decimal',
  maximumFractionDigits: 0,
  minimumIntegerDigits: 2
};
var decimal2FractionDigits = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};
var percentMax2FractionDigits = {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
};
export function formatPlain(value, locale) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return formatNumber(value, locale, Object.assign({}, plain, opts));
}
export function formatDecimal2MinIntegerNoFraction(value, locale) {
  return formatNumber(value, locale, decimal2MinIntegerNoFraction);
}
export function formatDecimal2FractionDigits(value, locale) {
  return formatNumber(value, locale, decimal2FractionDigits);
}
export function formatPercentMax2FractionDigits(value, locale) {
  return formatNumber(value, locale, percentMax2FractionDigits);
}
export function formatNumber(value, locale, format) {
  return new Intl.NumberFormat(locale, format).format(value);
}